import React from "react";
import Card from "../../components/Common/Card";
import TitleHeader from "../../components/Common/TitleHeader";
import { BlogContainer } from "../../helpers/StyledComponents";
import { styled } from "styled-components";
import { Button } from "antd";

const ThreeCards = () => {
  const currentDomain = `${window.location.protocol}//${window.location.hostname}`;
  const handleOnClick = (e) => {
    window.location.href = "all-activities";
  };
  return (
    <>
      <TitleHeader
        en="RECENT NEWS & ACTIVITIES"
        th="ข่าวสารและกิจกรรมล่าสุด"
        center
      />
      <BlogContainer maxWidth="1000" style={{ margin: "0px auto" }}>
        <CardContainer>
          <Card
            title="CREATION 2026 — More Than a Theory!"
            image="https://i.ibb.co/BHCSBKQy/S-35913756.jpg"
            detailLink={`${currentDomain}/activities?actNo=33`}
          />
          <Card
            title="THE CREATOR OF ALL THINGS"
            image="https://i.ibb.co/HDVtyZ7J/813715143-1380274464308949-3700003655852578331-n.jpg"
            detailLink={`${currentDomain}/activities?actNo=32`}
          />
          <Card
            title="ขอบคุณสำหรับวันที่เต็มไปด้วยพระพรและการเรียนรู้พระคำ"
            image="https://i.ibb.co/xqJHp5g7/797035443-1365431575793238-6032362806102442465-n.jpg"
            detailLink={`${currentDomain}/activities?actNo=31`}
          />
        </CardContainer>
      </BlogContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "20px auto",
        }}
      >
        <Button
          type="primary"
          shape="round"
          size="large"
          onClick={handleOnClick}
          style={{ fontWeight: "bold" }}
        >
          <div>กิจกรรมทั้งหมด</div>
        </Button>
      </div>
    </>
  );
};

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export default ThreeCards;
